import { render, staticRenderFns } from "./home_4.vue?vue&type=template&id=fb7c161a&scoped=true"
import script from "./home_4.vue?vue&type=script&lang=js"
export * from "./home_4.vue?vue&type=script&lang=js"
import style0 from "./home_4.vue?vue&type=style&index=0&id=fb7c161a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7c161a",
  null
  
)

export default component.exports